import { useState, useCallback } from "react";

interface ModalStates {
  delivery: boolean;
  guest: boolean;
  duplicate: boolean;
  discount: boolean;
}

export function useCartModals() {
  const [isBillingModalOpen, setIsBillingModalOpen] = useState(false);
  const [isCVVModalOpen, setIsCVVModalOpen] = useState(false);
  const [isDeliveryModalOpen, setIsDeliveryModalOpen] = useState(false);
  const [isPickUpOnlyModalOpen, setIsPickUpOnlyModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState<ModalStates>({
    delivery: false,
    guest: false,
    duplicate: false,
    discount: false,
  });

  const openBillingModal = useCallback(() => setIsBillingModalOpen(true), []);
  const closeBillingModal = useCallback(() => setIsBillingModalOpen(false), []);

  const openCVVModal = useCallback(() => setIsCVVModalOpen(true), []);
  const closeCVVModal = useCallback(() => setIsCVVModalOpen(false), []);

  const openDeliveryModal = useCallback(() => setIsDeliveryModalOpen(true), []);
  const closeDeliveryModal = useCallback(
    () => setIsDeliveryModalOpen(false),
    [],
  );

  const openPickUpOnlyModal = useCallback(
    () => setIsPickUpOnlyModalOpen(true),
    [],
  );
  const closePickUpOnlyModal = useCallback(
    () => setIsPickUpOnlyModalOpen(false),
    [],
  );

  const updateIsOpen = useCallback((key: keyof ModalStates, value: boolean) => {
    setIsOpen((prev) => ({ ...prev, [key]: value }));
  }, []);

  return {
    isBillingModalOpen,
    isCVVModalOpen,
    isDeliveryModalOpen,
    isPickUpOnlyModalOpen,
    isOpen,
    setIsOpen,
    openBillingModal,
    closeBillingModal,
    openCVVModal,
    closeCVVModal,
    openDeliveryModal,
    closeDeliveryModal,
    openPickUpOnlyModal,
    closePickUpOnlyModal,
    updateIsOpen,
  };
}
